import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Col,
  CustomInput,
  Form,
  FormGroup,
  FormText,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import {
  BtnOutlineGreen,
  BtnOutlineRed,
  ContFilterCheckbox,
} from '../../../styled-components';
import DateInput from '../../../commons/DateInput';
import { useAuth } from '../../../commons/Auth';
import { useAlert } from 'react-alert';

const INITAL_FILE_FORM_VALUES = {
  expireDate: '',
  file: '',
  needed: false,
  type: '',
  noExpireDate: false,
  softwareLabel: '',
};

function AddFileButton({
  profile = {},
  uploadFile,
  documentTypes,
  softwareLabels,
}) {
  const [t] = useTranslation('FILES');
  const alert = useAlert();
  const [{ newIsAdmin } = {}] = useAuth();
  const [addNewFileModal, setAddNewFileModal] = useState(false);
  const [formValues, setFormValues] = useState(INITAL_FILE_FORM_VALUES);
  const [errors, setErrors] = useState({
    expireDate: false,
    type: false,
    file: false,
    softwareLabel: false,
  });
  const [firstTry, setFirtsTry] = useState(true);
  const [documentType, setDocumentType] = useState('');

  useEffect(() => {}, [errors]);

  const toggleAddNewFileModal = () => {
    setFormValues(INITAL_FILE_FORM_VALUES);
    setAddNewFileModal(!addNewFileModal);
    setFirtsTry(true);
  };

  function handleFileChange() {
    const needed = formValues.needed;
    const noExpireDate = formValues.noExpireDate;
    const file = formValues.file;
    const type = formValues.type;
    const expireDate = formValues.expireDate;
    const softwareLabel = formValues.softwareLabel;

    const fileSize = (file.size / 1024 ** 2).toFixed(2);

    if (fileSize > 20) {
      alert.info('File troppo grande. Max 20Mb');
    } else {
      const data = new FormData();
      data.append('file', file);
      data.append('typeId', type);
      data.append('expireDate', expireDate);
      data.append('newIsAdmin', newIsAdmin);
      data.append('needed', needed);
      data.append('noExpireDate', noExpireDate);
      data.append('softwareLabel', softwareLabel);

      setFirtsTry(false);
      errors.file = false;
      errors.type = false;
      errors.expireDate = false;
      errors.softwareLabel = false;

      if (file === '') errors.file = true;
      if (type === '') errors.type = true;
      if (documentType === 'Software Utilizzato' && softwareLabel === '') {
        errors.softwareLabel = true;
      }
      if (expireDate === '' && noExpireDate === false) errors.expireDate = true;

      const arrayErrors = Object.values(errors);
      if (!arrayErrors.includes(true)) {
        uploadFile(data, toggleAddNewFileModal);
      }
    }
  }

  return (
    <React.Fragment>
      <Button
        target="_blank"
        color="primary"
        style={{ marginTop: 0 }}
        onClick={(event) => {
          event.stopPropagation();
          toggleAddNewFileModal();
        }}
      >
        Aggiungi
      </Button>

      <Modal
        isOpen={addNewFileModal}
        toggle={toggleAddNewFileModal}
        className="new-file-modal"
      >
        <ModalHeader toggle={toggleAddNewFileModal}>
          {t('FILES:ADD')}
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            handleFileChange();
          }}
        >
          <ModalBody>
            <Row>
              <Col sm="12">
                <FormGroup>
                  <Label for="selectFile">
                    {t('FILES:CHOOSE_FILE')}
                    &nbsp;({t('FILES:MAX_UPLOAD_FILE_SIZE')})
                  </Label>
                  <CustomInput
                    type="file"
                    id="fileCommercialContract"
                    name="fileCommercialContract"
                    accept="application/pdf"
                    onChange={(event) =>
                      setFormValues({
                        ...formValues,
                        file: event.target.files[0],
                      })
                    }
                  />
                  {formValues.file === '' && !firstTry && (
                    <FormText className="error-message">
                      {t('FILE_ERROR')}
                    </FormText>
                  )}
                </FormGroup>
              </Col>
            </Row>
            {formValues.file !== '' && (
              <div
                style={{
                  margin: '5px',
                  backgroundColor: '#F7F8FA',
                }}
              >
                <Row>
                  <Col sm="12">
                    <span style={{ overflowX: 'hidden' }}>
                      {formValues.file?.name}
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <FormGroup>
                      <Label>{t('TYPE')}</Label>
                      <CustomInput
                        type="select"
                        id="type"
                        name="type"
                        value={formValues.type}
                        defaultValue={formValues.type}
                        onChange={({ target: { value } }) => {
                          const selectedDocumentType = documentTypes.find(
                            (documentType) => documentType._id === value
                          );
                          setFormValues({
                            ...formValues,
                            type: value,
                            softwareLabel: '',
                          });
                          setDocumentType(selectedDocumentType.name);
                        }}
                      >
                        <option value={''}>Seleziona un tipo</option>
                        {documentTypes.map((documentType) => (
                          <option
                            key={documentType._id}
                            value={documentType._id}
                          >
                            {documentType.name}
                          </option>
                        ))}
                      </CustomInput>
                      {formValues.type === '' && !firstTry && (
                        <FormText className="error-message">
                          {t('TYPE_ERROR')}
                        </FormText>
                      )}
                    </FormGroup>
                  </Col>
                  {documentType === 'Software Utilizzato' && (
                    <Col sm="12">
                      <FormGroup>
                        <Label>{t('SOFTWARE_LABELS')}</Label>
                        <CustomInput
                          type="select"
                          id="softwareLabel"
                          name="softwareLabel"
                          value={formValues.softwareLabel}
                          defaultValue={formValues.softwareLabel}
                          onChange={({ target: { value } }) => {
                            setFormValues({
                              ...formValues,
                              softwareLabel: value,
                            });
                            setErrors({
                              ...errors,
                              softwareLabel: false,
                            });
                          }}
                        >
                          <option value={''}>Seleziona un tipo</option>

                          {softwareLabels.map((softwareLabel) => (
                            <option key={softwareLabel} value={softwareLabel}>
                              {softwareLabel}
                            </option>
                          ))}
                        </CustomInput>
                        {errors.softwareLabel && (
                          <FormText className="error-message">
                            {t('SOFTWARE_LABEL_ERROR')}
                          </FormText>
                        )}
                      </FormGroup>
                    </Col>
                  )}
                  <Col xs="12">
                    <FormGroup>
                      <Label>{t('EXPIRE_DATE')}</Label>
                      <DateInput
                        name="expireDate"
                        value={formValues.expireDate}
                        onChange={(val) =>
                          setFormValues({
                            ...formValues,
                            expireDate: val,
                          })
                        }
                        disabled={formValues.noExpireDate}
                      />
                      {formValues.expireDate === '' &&
                        formValues.noExpireDate === false &&
                        !firstTry && (
                          <FormText className="error-message">
                            {t('DATES_ERROR')}
                          </FormText>
                        )}
                    </FormGroup>
                  </Col>
                  <Col xs="12">
                    <FormGroup>
                      <ContFilterCheckbox>
                        <CustomInput
                          type="checkbox"
                          id="noExpireDate"
                          name="noExpireDate"
                          label={t('NO_EXPIRE_DATE')}
                          onChange={(e) => {
                            e.stopPropagation();
                            setFormValues({
                              ...formValues,
                              noExpireDate: !formValues.noExpireDate,
                              expireDate: '',
                            });
                          }}
                        />
                      </ContFilterCheckbox>
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <BtnOutlineRed
              type="button"
              className="uppercase"
              onClick={toggleAddNewFileModal}
            >
              {t('COMMON:CANCEL')}
            </BtnOutlineRed>
            <BtnOutlineGreen type="submit" className="uppercase">
              {t('COMMON:CONFIRM')}
            </BtnOutlineGreen>
          </ModalFooter>
        </Form>
      </Modal>
    </React.Fragment>
  );
}

export default AddFileButton;
